export default __webpack_public_path__ + "static/media/404-page.2be6393a.png";